import {Component, Input} from '@angular/core';
import {DatePipe} from "@angular/common";
import {RouterLink} from "@angular/router";
import {Review, REVIEW_SOURCE_LABELS} from "../../models/review";
import {StarRatingComponent} from "../star-rating/star-rating.component";

/** One review: stars, text, who wrote it and where. Used under products and on the home page. */
@Component({
    selector: 'app-review-card',
    standalone: true,
    imports: [DatePipe, RouterLink, StarRatingComponent],
    template: `
        <article class="h-full flex flex-col rounded-lg border border-gray-200 bg-white p-4 text-left shadow-sm">
            <div class="flex items-center justify-between gap-2">
                <app-star-rating [rating]="review.rating"></app-star-rating>
                <time class="text-xs text-gray-500" [attr.datetime]="review.createdAt">{{ review.createdAt | date:'d.M.yyyy' }}</time>
            </div>
            <p class="pt-2 text-sm lg:text-base text-gray-800 whitespace-pre-line" [class.line-clamp-6]="compact">{{ review.text }}</p>
            <div class="mt-auto pt-3 text-sm">
                <p class="font-medium text-gray-900">
                    {{ review.authorName }}@if (review.city) {<span class="font-normal text-gray-600">, {{ review.city }}</span>}
                </p>
                <p class="flex flex-wrap items-center gap-x-2 text-xs text-gray-600">
                    @if (review.verifiedPurchase) {
                        <span class="inline-flex items-center gap-1 text-primaryDark font-medium">
                            <span aria-hidden="true">✓</span> Потврден купувач
                        </span>
                    }
                    @if (sourceLabel) {
                        <span>{{ sourceLabel }}</span>
                    }
                </p>
                @if (review.productName && review.productSlug) {
                    <a class="block pt-1 text-xs text-primaryDark underline"
                       [routerLink]="'/shop/product/' + review.productSlug + '-' + review.productId">{{ review.productName }}</a>
                }
            </div>
        </article>
    `
})
export class ReviewCardComponent {

    @Input({required: true})
    review!: Review;

    /** Long texts cut to six lines - for the home page grid. */
    @Input()
    compact: boolean = false;

    get sourceLabel(): string {
        return REVIEW_SOURCE_LABELS[this.review.source] ?? '';
    }
}
